import React from "react";
import { getAuthToken } from "../../../redux/reducers/auth";
import { useAppSelector } from "../../../redux/hooks";
import LoadingSpinner from "../../../common/LoadingSpinner";
import OfferHistory from "./OfferHistory";
import { useGetOffer } from "../../../utils/useOffer";
import { getUserId } from "../../../redux/reducers/user";
import { useQuery } from "../../../utils/GeneralUtils";
import { getCurrentPage } from "../../../common/archive/ListSearchFunc";

const OfferHistoryContainer: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);
  const userId = useAppSelector(getUserId);

  const FetchContainer: React.FC<{ authToken: string; userId: string }> = ({
    authToken,
    userId,
  }) => {
    const query = useQuery();
    const currentPage = getCurrentPage(query);

    const { offers, meta, total_entries, total_pages, isLoading } = useGetOffer(
      { auth_token: authToken, page: currentPage, per: 10 }
    );

    return (
      <OfferHistory
        ownUserId={userId}
        offers={offers}
        meta={meta}
        totalEntries={total_entries}
        currentPage={currentPage}
        totalPages={total_pages}
        isLoading={isLoading}
      />
    );
  };

  if (auth_token && userId) {
    return <FetchContainer authToken={auth_token} userId={userId} />;
  } else {
    return <LoadingSpinner space={1} />;
  }
};

export default OfferHistoryContainer;
